<template>
  <div class="container">
    <div style="padding-right: 5px">
      <div class="card-header">Assess</div>
      <div
        style="display: flex"
        v-for="item in phaseAssess"
        :key="item.EventTemplateID"
      >
        <div>
          <font-awesome-icon
            style="color: gray; font-size: 10px; width: 10px"
            :icon="['fa', 'circle']"
          ></font-awesome-icon>
        </div>
        <div style="padding-left: 10px">
          <div>{{ item.EventFriendlyName }}</div>
          <div v-if="item.ClientDescription != null" class="clientDescription">
            {{ item.ClientDescription }}
          </div>
        </div>
      </div>
    </div>
    <div style="padding-right: 5px">
      <div class="card-header">Install</div>
      <div
        style="display: flex"
        v-for="item in phaseInstall"
        :key="item.EventTemplateID"
      >
        <div>
          <font-awesome-icon
            style="color: gray; font-size: 10px; width: 10px"
            :icon="['fa', 'circle']"
          ></font-awesome-icon>
        </div>
        <div style="padding-left: 10px">
          <div>{{ item.EventFriendlyName }}</div>
          <div v-if="item.ClientDescription != null" class="clientDescription">
            {{ item.ClientDescription }}
          </div>
        </div>
      </div>
    </div>
    <div style="padding-right: 5px">
      <div class="card-header">Live</div>
      <div
        style="display: flex"
        v-for="item in phaseLive"
        :key="item.EventTemplateID"
      >
        <div>
          <font-awesome-icon
            style="color: gray; font-size: 10px; width: 10px"
            :icon="['fa', 'circle']"
          ></font-awesome-icon>
        </div>
        <div style="padding-left: 10px">
          <div>{{ item.EventFriendlyName }}</div>
          <div v-if="item.ClientDescription != null" class="clientDescription">
            {{ item.ClientDescription }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CurrentMilestonePopup",
  data() {
    return {
      user: this.$auth.user.UserDetails,
      phaseInstall: [],
      phaseQuoting: [],
      phaseLive: [],
      phaseAssess: [],
    };
  },
  mounted: function () {
    this.LoadCurrMilestoneHeader();
  },
  methods: {
    LoadCurrMilestoneHeader() {
      let url = `https://api.ccr.net/ColoM360/MilestoneDefintion_view?$filter=(TemplateID eq 11)&$orderby= EventOrder`;
      this.$axios.get(url).then((response) => {
        response.data.value.forEach((element) => {
          if (element.PhaseName == "Install") {
            this.phaseInstall.push(element);
          }
          if (element.PhaseName == "Quoting") {
            this.phaseQuoting.push(element);
          }
          if (element.PhaseName == "Live") {
            this.phaseLive.push(element);
          }
          if (element.PhaseName == "Assess") {
            this.phaseAssess.push(element);
          }
        });
      });

      // this.phaseInstall.sort((a, b) => (a.EventOrder > b.EventOrder ? 1 : -1));
      // this.phaseQuoting.sort((a, b) => (a.EventOrder > b.EventOrder ? 1 : -1));
      // this.phaseLive.sort((a, b) => (a.EventOrder > b.EventOrder ? 1 : -1));
    },
  },
};
</script>
<style scoped>
.card-header {
  color: white;
  background-color: #006ca5;
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 18px;
  text-align: center;
}
.container {
  display: flex;
}
.container > div {
  flex: 1; /*grow*/
}
.clientDescription {
  font-style: italic;
  padding-left: 0px;
}
</style>
  